<script>
import {
  uploadFiles,
  getProfessorApplicationByNetId,
} from "../services/services";
import MessageDialog from "../components/MessageDialog";
import LSDatePicker from "../components/LSDatePicker.vue";

export default {
  name: "ProfessorRecommendation",
  components: { MessageDialog, LSDatePicker },
  data() {
    return {
      application: {
        id: 0,
        firstName: "",
        lastName: "",
        netId: "",
        major: "",
        yearInSchool: "",
        gpa: "",
        phoneNumber: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        citizenship: "Yes",
        fellowships: ["", "", ""],
        locationOfInternship: "",
        startDate: "",
        endDate: "",
        year: "",
        courseNumber: "",
        semester: "",
        department: "",
        resume: {},
        letter: {},
        professorSendSeperate: "No",
        researchExperience: "",
        careerAspirations: "",
        uniqueQualifications: "",
        digitalSignature: "",
        professorEmail: "",
      },
      citizenshipOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      panel: [0, 1],
      resume: {},
      letter: {},
      thankYouNote: {},
      exists: false,
      showAlert: false,
      success: false,
    };
  },
  async mounted() {
    const netId = this.$route.query.netId;
    if (!!netId) {
      this.netId == netId;
      try {
        const data = await getProfessorApplicationByNetId(netId);
        const app = { ...data };
        if (!!app.dateSubmitted) {
          this.exists = true;
          this.application = app;
        } else {
          this.$router.push("error");
        }
      } catch {
        this.$router.push("error");
      }
    } else {
      this.$router.push("error");
    }
  },
  computed: {
    startYear() {
      const NOW = new Date();
      return NOW.getFullYear();
    },
  },
  methods: {
    async uploadFiles() {
      const form = new FormData();
      if (!!this.letter) {
        form.append(`l-${this.letter.name}`, this.letter);
      } else {
        return;
      }
      await uploadFiles(form, this.application.id);
    },

    async submit() {
      if (!!this.letter?.name) {
        try {
          await this.uploadFiles();
          this.success = true;
          this.showAlert = true;
        } catch (e) {
          console.log("Failed to submit letter of recommendation", e);
          this.success = false;
          this.showAlert = true;
        }
      }
    },

    closeDialog() {
      this.showAlert = false;
    },
  },
  watch: {
    application(val) {
      this.letter = {
        name: val?.letterOfReccomendation?.fileName,
      };
    },
  },
};
</script>

<template>
  <v-layout column v-if="exists">
    <h1 style="padding-bottom: 16px">
      Letter of Recommendation for: {{ application.firstName }}
      {{ application.lastName }}
    </h1>
    <v-layout style="padding-bottom: 16px">
      Please upload a letter of recommendation in the space below.
    </v-layout>
    <MessageDialog
      :title="success ? 'Submitted Successfully' : 'Something Went Wrong'"
      :message="
        success
          ? 'Letter of Recommendation Submitted Successfully.\nThank you.'
          : 'An error occured when attempting to submit the letter of recommendation. Please try again later.'
      "
      :show="showAlert"
      v-on:close="closeDialog"
    />

    <v-layout>
      <v-flex>
        <v-file-input
          outlined
          label="Letter of Recommendation"
          v-model="letter"
        ></v-file-input>
      </v-flex>
    </v-layout>
    <v-layout justify-end>
      <v-btn color="primary" @click="submit">Submit</v-btn>
    </v-layout>
  </v-layout>
  <v-layout column v-else>
    <h1 style="padding-bottom: 16px">User not found</h1>
  </v-layout>
</template>

<style scoped>
#add-new-fellowship {
  height: 54px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  transition: 0.2s;
  display: flex;
  align-items: center;
  padding-left: 12px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.42);
}
#add-new-fellowship:hover {
  border-color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
}
</style>
